import adminApi from '../../components/apis/adminApi';
import api from '../../components/apis/api';

export async function getStationByIdService(id) {
  return adminApi.get(`/api/admin/stations/${id}`).then((res) => res.data);
}

export async function editStationService(id, values) {
  return adminApi.put(`/api/admin/stations/${id}`, values).then((res) => res.data);
}

export async function getSuggestedStations() {
  return api.get('/api/stations/suggested').then((res) => res.data);
}

export async function addSuggestedStations(values) {
  return adminApi.post('/api/admin/stations/suggested', values).then((res) => res.data);
}

export async function deleteSuggestedStation(id) {
  return adminApi.delete(`/api/admin/stations/suggested/${id}`).then((res) => res.data);
}
